export function validateCivilRegistrationNumber(civilRegistrationNumber: string) {
  const formats: { [key: string]: RegExp } = {
    dk: /^[0-9]{6}-[0-9]{4}$/,
    no: /^[0-9]{6}-[0-9]{5}$/,
    se: /^[0-9]{6}-[0-9]{4}$/,
    fi: /^[0-9]{6}[-+a][0-9]{3}[a-z0-9]$/
  }

  for (const countryFormat in formats) {
    if (formats[countryFormat].test(civilRegistrationNumber)) {
      return true
    }
  }

  return false
}
